import { CustomerTag } from "../../../utils/moduleTags/customerTag";
import { ProjectTag } from "../../../utils/moduleTags/projectTag";
import { CustomerSystemTag } from "../../../utils/moduleTags/customerSystemTag";
import { ModuleTag } from "../../../utils/moduleTags/moduleTag";
import {
  ServiceAgreementIntervalById,
  ServiceAgreementNextServiceStatus,
} from "./utils";
import { dateToString } from "../../../Utils";
import { DeliveryAddressSection } from "../../customers/deliveryAddresses/addressSection";
import { ServiceAgreementSubs } from "./service-agreement-subs";
import { ContactSection } from "../../projects/ContactSection";

export const ServiceAgreementInfo = (props) => {
  const { item, onRefresh } = props;

  return (
    <>
      <div className="mt-5 shadow sm:overflow-hidden sm:rounded-md">
        <div className="bg-gradient-to-r from-slate-50 to-gray-50 px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-lg font-semibold text-gray-900">Detaljer</h3>
                <p className="text-sm text-gray-600">Informasjon om serviceavtalen</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white px-6 py-6">
          <dl className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3">
            <div className="sm:col-span-1">
              <CustomerTag customer={item?.customer} />
            </div>
            <div className="sm:col-span-1">
              <ProjectTag project={item?.project} folder={item?.folder} />
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">Type</dt>
              <dd className="mt-1 text-sm text-gray-900">
                {item?.type?.displayTitle}
              </dd>
            </div>
            <div className="sm:col-span-1">
              <CustomerSystemTag
                customer={item?.customer}
                selected={item?.system}
              />
            </div>
          </dl>
        </div>
      </div>

      {item?.contact?.id && (
        <ContactSection contactId={item?.contact?.id} className="mt-5" />
      )}

      {/* Description START */}
      {item?.description && (
        <div className="mt-5 shadow sm:overflow-hidden sm:rounded-md">
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-gray-900">Beskrivelse</h3>
                  <p className="text-sm text-gray-600">Detaljert beskrivelse av serviceavtalen</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white px-6 py-6">
            <div className="prose prose-sm max-w-none text-gray-700">
              <div dangerouslySetInnerHTML={{ __html: item?.description }} />
            </div>
          </div>
        </div>
      )}
      {/* Description END */}

      {/* agreement_text START */}
      {item?.agreement_text && (
        <div className="mt-5 shadow sm:overflow-hidden sm:rounded-md">
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                    <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-gray-900">Avtaletekst</h3>
                  <p className="text-sm text-gray-600">Tekst som skal vises i avtalen</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white px-6 py-6">
            <div className="prose prose-sm max-w-none text-gray-700">
              <div dangerouslySetInnerHTML={{ __html: item?.agreement_text }} />
            </div>
          </div>
        </div>
      )}
      {/* agreement_text END */}

      <div className="mt-5 shadow sm:overflow-hidden sm:rounded-md">
        <div className="bg-gradient-to-r from-teal-50 to-cyan-50 px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-lg font-semibold text-gray-900">Interval</h3>
                <p className="text-sm text-gray-600">Serviceintervall og datoer</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white px-6 py-6">
          <dl className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3">
            <div className="sm:col-span-1">
              <ModuleTag label="Interval">
                {ServiceAgreementIntervalById(item?.interval?.id).label}
              </ModuleTag>
            </div>
            <div className="sm:col-span-1">
              <ModuleTag label="Dato for neste">
                {dateToString(item?.next_service_date)}
              </ModuleTag>
            </div>
            <div className="sm:col-span-1">
              <ModuleTag label="Dager til neste service">
                <ServiceAgreementNextServiceStatus serviceAgreement={item} />
              </ModuleTag>
            </div>
            <div className="sm:col-span-1">
              <ModuleTag label="Forrige service">
                {dateToString(item?.last_service_date)}
              </ModuleTag>
            </div>
          </dl>
        </div>
      </div>
      <div className="mt-5">
        <DeliveryAddressSection address={item?.delivery_address} />
      </div>
      
      <ServiceAgreementSubs agreement={item} onRefresh={onRefresh} />
    </>
  );
};
